import type { Course } from "../lib/types";

export const COURSES: Course[] = [
  {
    id: "foundations",
    num: "01",
    title: "Git, in plain English",
    desc: "What version control actually is and why git is the standard. No commands yet — just the mental model.",
    duration: "12 min",
    lessons: 4,
    progress: 0,
    status: "available",
    art: "book",
  },
  {
    id: "commits-branches",
    num: "02",
    title: "Commits & branches",
    desc: "Repos, working tree, staging, commits. Then branches — what they really are and how to use them.",
    duration: "24 min",
    lessons: 7,
    progress: 0.42,
    status: "in-progress",
    art: "branch",
    primary: true,
  },
  {
    id: "remote",
    num: "03",
    title: "Remote vs local",
    desc: "origin, push, pull, fetch, clone. The difference between your laptop and what's on GitHub.",
    duration: "18 min",
    lessons: 5,
    progress: 0,
    status: "available",
    art: "cloud",
  },
  {
    id: "pull-requests",
    num: "04",
    title: "Pull requests on GitHub",
    desc: "The PR workflow most teams use day-to-day. Opening, reviewing, approving, merging.",
    duration: "22 min",
    lessons: 6,
    progress: 0,
    status: "available",
    art: "pr",
    badge: "New",
  },
  {
    id: "merge-conflicts",
    num: "05",
    title: "Merge conflicts, calmly",
    desc: "What conflicts actually are, why they happen, and a step-by-step you can rely on to resolve them.",
    duration: "20 min",
    lessons: 5,
    progress: 0,
    status: "available",
    art: "conflict",
  },
  {
    id: "undoing",
    num: "06",
    title: "Undoing & recovering",
    desc: "Revert, reset, reflog. Why you basically can't lose work in git if you know where to look.",
    duration: "16 min",
    lessons: 6,
    progress: 0,
    status: "available",
    art: "undo",
  },
];
